import { render } from "./QuotaSummaryResource.vue?vue&type=template&id=8c5f6fae"
import script from "./QuotaSummaryResource.vue?vue&type=script&lang=js"
export * from "./QuotaSummaryResource.vue?vue&type=script&lang=js"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__